export default __webpack_public_path__ + "opaleye_spotlight.25d1379c.png";